import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { markAsRead } from "@api/channels/messages/markAsRead/path";

const pathBase = `/channels/:id/messages`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const messages = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  markAsRead,
} as const;
